import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["aria-expanded"]
const _hoisted_2 = {
  key: 0,
  class: "search-multiselect-menu"
}
const _hoisted_3 = { class: "search-multiselect-search" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = { class: "search-multiselect-options" }
const _hoisted_6 = ["checked", "onChange"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "search-multiselect-empty"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "root",
    class: _normalizeClass(["search-multiselect", {open: $setup.open}])
  }, [
    _createElementVNode("button", {
      type: "button",
      class: "search-multiselect-trigger",
      "aria-expanded": $setup.open,
      onClick: _cache[0] || (_cache[0] = $event => {$setup.open=!$setup.open;$setup.search=''})
    }, [
      _createElementVNode("span", {
        class: _normalizeClass({placeholder:!$props.modelValue.length})
      }, _toDisplayString($setup.summary), 3 /* TEXT, CLASS */),
      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "chevron" }, "⌄", -1 /* CACHED */))
    ], 8 /* PROPS */, _hoisted_1),
    ($setup.open)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.search) = $event)),
              placeholder: $props.searchPlaceholder,
              type: "search",
              autofocus: ""
            }, null, 8 /* PROPS */, _hoisted_4), [
              [_vModelText, $setup.search]
            ]),
            ($props.modelValue.length)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  onClick: $setup.clear
                }, "Очистить"))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredOptions, (option) => {
              return (_openBlock(), _createElementBlock("label", {
                key: option.id,
                class: _normalizeClass({selected:$setup.selectedSet.has($setup.normalized(option.id))})
              }, [
                _createElementVNode("input", {
                  type: "checkbox",
                  checked: $setup.selectedSet.has($setup.normalized(option.id)),
                  onChange: $event => ($setup.toggle(option))
                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_6),
                _createElementVNode("span", null, [
                  _createElementVNode("strong", null, _toDisplayString(option.name), 1 /* TEXT */),
                  (option.meta)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_7, _toDisplayString(option.meta), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ])
              ], 2 /* CLASS */))
            }), 128 /* KEYED_FRAGMENT */)),
            (!$setup.filteredOptions.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Ничего не найдено"))
              : _createCommentVNode("v-if", true)
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}